<template>
	<div style="width: 100%; height: 100%; background:#fff">
		<div class="invoice-box" style="background:#fff">
			<div id="print_area" style="background:#fff">
				<br>
				<img class="img_header" v-bind:src="pv['carparkHeader']" style="width: 100%;">
				<br>
				<div style="float:right">
					<h2 class="right" style="font-size: 1.5em; font-weight: bold;">PAYMENT VOUCHER</h2>
					<table>
						<tbody>
							<tr>
								<td>Parking License No:</td>
								<td></td>
								<td class="right"><b>{{pv['parkingLicense']}}</b></td>
								<td></td>
							</tr>
							<tr>
								<td>PV No:</td>
								<td></td>
								<td class="right"><b>{{pv['pvNo']}}</b></td>
								<td></td>
							</tr>
							<tr>
								<td>Date:</td>
								<td></td>
								<td class="right"><b>{{pv['date']}}</b></td>
								<td></td>
							</tr>
							<tr v-show="pv['refundMethod']">
								<td>Refund Method:</td>
								<td></td>
								<td class="right"><b>{{pv['refundMethod']}}</b></td>
								<td></td>
							</tr>
							<tr>
								<td>PV Status:</td>
								<td></td>
								<td class="right"><b>{{pv['pvStatus']}}</b></td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
				<div><b>{{pv['carparkName']}}</b>
					<div v-show="pv['carparkAddress1']">{{pv['carparkAddress1']}}</div>
					<div v-show="pv['carparkAddress2']">{{pv['carparkAddress2']}}</div>
					<div v-show="pv['carparkAddress3']">{{pv['carparkAddress3']}}</div>
					<div>{{pv['carparkAddressPostCodeAndCity']}}</div>
					<div>{{pv['carparkAddressStateAndCountry']}}</div>
					<div>Telephone: {{pv['carparkTelephone']}}</div>
					<div>Fax: {{pv['carparkFax']}}</div>
					<div>Email: {{pv['carparkEmail']}}</div>
					<div>Website: {{pv['carparkWebsite']}}</div>
				</div><br>TO:<div><b>{{pv['customerName']}}</b>
					<div v-show="pv['customerAddress1']">{{pv['customerAddress1']}}</div>
					<div v-show="pv['customerAddress2']">{{pv['customerAddress2']}}</div>
					<div v-show="pv['customerAddress3']">{{pv['customerAddress3']}}</div>
					<div>{{pv['customerAddressPostCodeAndCity']}}</div>
					<div>{{pv['customerAddressStateAndCountry']}}</div>
				</div><br>
				<div v-show="pv['customerPIC']">ATTENTION: {{pv['customerPIC']}}</div>
				<table class="bordered-table" style="width: 100%">
					<tbody>
						<tr>
							<th class="bordered-table center" colspan="1" style="">Description</th>
							<th class="bordered-table center" colspan="1" style="">Amount Paid (RM)</th>
						</tr>
						<tr>
							<td class="bordered-table left" colspan="1" style="" >
								<div v-html="(pv['description'] || '').replaceAll('\n', '<br>')"></div>
								<br>
								<b>
									Refund Request Form Reference: {{pv['termination']}}
								</b>
							</td>
							<td class="bordered-table right" colspan="1" style="">{{pv['amount']}}</td>
						</tr>
						<tr>
							<td class="bordered-table right" colspan="1" style=""><b>Total</b></td>
							<td class="bordered-table right" colspan="1" style=""><b>RM {{pv['amount']}}</b></td>
						</tr>
					</tbody>
				</table>
				<br>
				<br>
				We enclose the following refund information in the above items:
				<table class="bordered-table" style="width: auto">
					<tbody>
						<tr
							v-for="(key, index) of pv['col1']"
							v-bind:key="'refund_info_' + index">
							<td class="bordered-table" colspan="1" style="" v-html="pv['col1'][index]"></td>
							<td class="bordered-table" colspan="1" style="" v-html="pv['col2'][index]"></td>
						</tr>
					</tbody>
				</table>
				<br>
				<br>
				<div>This is a computer generated document. No signature is required</div><br>
				<img class="img_footer" v-bind:src="pv['carparkFooter']" style="width: 100%;">
			</div>
		</div>
	</div>
	
</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PagePV",
  data () {
    return {
			pv: {},
    }
  },
  mounted() {
		this.pv = this.$route.query
		console.log(this.pv)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Page/Refund/PagePV.vue